"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DayClassNameEnum;
(function (DayClassNameEnum) {
    DayClassNameEnum["isToday"] = "is-today";
    DayClassNameEnum["isMonth"] = "is-month";
    DayClassNameEnum["isOutside"] = "is-outside";
    DayClassNameEnum["isDisabled"] = "is-disabled";
})(DayClassNameEnum = exports.DayClassNameEnum || (exports.DayClassNameEnum = {}));
